module.exports = __webpack_public_path__ + "img/07_shimizu_14.8d1a932b.jpg";